import { useEffect } from 'react';

import { Helmet } from '@xing-com/crate-helmet';

import { adSlotConfigPublift, getAdSlotIds } from './ad-slot-config-publift';
import { adTrackingParams } from './ad-tracking-params';
import { useDisplayAdTracking } from './hooks';
import type { PageInitOptions } from './publift.types';

type BiddingScriptTypes = {
  trackingParams: {
    page: string;
    sentBy: string;
  };
};

type FuseTagType = {
  pageInit?: (options: PageInitOptions) => void;
  onSlotViewable?: (
    listener: (event: {
      slotId: string;
      gptEvent: googletag.events.ImpressionViewableEvent;
    }) => void
  ) => void;
  registerZone?: (slotId: string) => void;
  que: Array<() => void>;
};

declare global {
  interface Window {
    fusetag?: FuseTagType;
  }
}

type PubliftSlotConfig =
  (typeof adSlotConfigPublift)[keyof typeof adSlotConfigPublift];

const publiftSlotConfigByPage: Partial<Record<string, PubliftSlotConfig>> = {
  [adTrackingParams.Startpage.page]: adSlotConfigPublift.Startpage,
  [adTrackingParams.Login.page]: adSlotConfigPublift.Login,
  [adTrackingParams.Profile.page]: adSlotConfigPublift.Profile,
};

export const DisplayAdsBiddingScriptPublift: React.FC<BiddingScriptTypes> = ({
  trackingParams,
}) => {
  const { sentBy, page } = trackingParams;
  const { onViewableListener } = useDisplayAdTracking({
    sentBy,
    page,
    isPublift: true,
  });

  useEffect(() => {
    const publiftSlotConfig = publiftSlotConfigByPage[page];
    const fuseIds = publiftSlotConfig ? getAdSlotIds(publiftSlotConfig) : [];

    const fusetag = window.fusetag || (window.fusetag = { que: [] });

    fusetag.que.push(() => {
      fusetag.pageInit?.({
        // Defer the first auction until FuseIds are registered
        blockingFuseIds: fuseIds,
      });

      // @ts-expect-error Publift uses different types. Align after a/b test.
      fusetag.onSlotViewable?.(onViewableListener);
    });
  }, [onViewableListener, page]);

  return (
    <Helmet>
      <script
        async
        src="https://cdn.fuseplatform.net/publift/tags/2/4306/fuse.js"
      ></script>
    </Helmet>
  );
};
